<template>
  <div class="video-page-wrapper">
    <div class="buttons-outer">
      <div class="dropdown-btn" :class="{ 'dropdown-open': showAllButtons }" @click="showAllButtons = !showAllButtons">
        Show all
        <font-awesome-icon
          :icon="['fas', showAllButtons ? 'chevron-up' : 'chevron-down']"
        />
      </div>
      <div class="buttons-wrapper">
        <FunctionalityButton
          v-for="(sensor, i) in sensors"
          :key="i"
          :name="sensor.name"
          :on-click="() => btnClick(i)"
          :active="isActive(i)"
          :icon="sensor.icon"
          class="f-btn"
          :class="{
          'btn-active': isActive(i),
          'btn-not-active': !isActive(i) && !showAllButtons
         }"
        />
      </div>
    </div>
    <IphoneVideo
      :key="currentlyActive"
      :video-name="sensors[currentlyActive].video"
    ></IphoneVideo>
    <IphoneVideo
      v-if="currentlyActive < sensors.length - 1"
      style="opacity: 0; position: fixed; left: 400%"
      :key="currentlyActive + 1"
      :video-name="sensors[currentlyActive + 1].video"
    ></IphoneVideo>
    <div class="video-page-texts">
      <div>
        <h3>{{ sensors[currentlyActive].title }}</h3>
        <p>
          {{ sensors[currentlyActive].description }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import FunctionalityButton from "../components/blocks/FunctionalityButton";

export default {
  name: "Sensors",
  components: { FunctionalityButton },
  data() {
    return {
      currentlyActive: 0,
      showAllButtons: false,
      sensors: [
        {
          ...this.$t("pages.sensors.motion"),
          icon: "presence",
          video: this.requireVideo("motion")
        },
        {
          ...this.$t("pages.sensors.occupancy"),
          icon: "presence",
          video: this.requireVideo("occupancy")
        },
        {
          ...this.$t("pages.sensors.temperature"),
          icon: "presence",
          video: this.requireVideo("temperature")
        },
        {
          ...this.$t("pages.sensors.humidity"),
          icon: "presence",
          video: this.requireVideo("humidity")
        },
        {
          ...this.$t("pages.sensors.brightness"),
          icon: "presence",
          video: this.requireVideo("brightness")
        },
        {
          ...this.$t("pages.sensors.smoke"),
          icon: "presence",
          video: this.requireVideo("smoke")
        },
        {
          ...this.$t("pages.sensors.CO2"),
          icon: "presence",
          video: this.requireVideo("CO2")
        },
        {
          ...this.$t("pages.sensors.contact"),
          icon: "presence",
          video: this.requireVideo("contact")
        }
        // { name: "Leak", icon: "presence", video: "room-management", title: "", description: ""  },
      ]
    };
  },
  methods: {
    requireVideo(name) {
      return require(`@/assets/videos/${name}.mp4`);
    },
    btnClick(i) {
      this.currentlyActive = i;
      this.showAllButtons = false;
    },
    isActive(i) {
      return this.currentlyActive === i;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../common/_variables.scss";

.buttons-wrapper {
  margin-right: 60px;
  min-width: 200px;
}
.f-btn {
  margin-bottom: 10px;
}
.btn-active {
  width: 170px;
}
.dropdown-btn {
  display: none;
}

@media only screen and (max-width: $screen-md) {
  .buttons-wrapper {
    margin-right: 0;
    min-width: unset;
  }
  .buttons-outer {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 20px;
  }
  .btn-active {
    width: 150px;
  }
  .dropdown-btn {
    display: block;
    margin-bottom: 10px;
    cursor: pointer;
    margin-right: 15px;
  }
  .dropdown-open {
    margin-top: 17px;
    align-self: flex-start;
  }
  .btn-not-active {
    display: none;
  }
  .grow {
    transition: none;
  }
  .grow:hover {
    transform: none;
  }
}
</style>
